//@flow
import {Axios} from "axios";
import {axiosDmsInstance} from "../../api";
import type {DmsPart, DmsTask} from "../event/model/dmsOrders";


class DmsService {
	axios: Axios;

	constructor() {
		this.axios = axiosDmsInstance;
	}

	async getOrders(customerNumber: string): Promise<void> {
		return this.axios.get("/order", {
			params: { customerNumber }
		});
	}

	async getOrderById(orderId: string): Promise<void> {
		return this.axios.get(`/order/${orderId}`);
	}

	async getLocalStock(partNumbers: string[]): Promise<void> {
		return this.axios.post("/products/stock", {partNumbers});
	}

	async getVehicleByVin(vin: string): Promise<void> {
		return this.axios.get(`/vehicle/vin/${vin}`);
	}

	async searchVehiclesByLicensePlate(licensePlate: string): Promise<void> {
		return this.axios.post("/vehicle/licensePlate", {licensePlate});
	}

	async searchVehiclesByCustomerName(name: string): Promise<void> {
		return this.axios.post("/vehicle/customer/name", {name});
	}

	async searchVehiclesByCustomerEmail(email: string): Promise<void> {
		return this.axios.post("/vehicle/customer/email", {email});
	}

	async searchVehiclesByCustomerPhone(phone: string): Promise<void> {
		return this.axios.post("/vehicle/customer/phone", {phone});
	}

	async addPartToOrder(orderId: string, partNumber: string, quantity: number): Promise<void> {
		return this.axios.post(`/order/${orderId}/part`,
			{
				partNumber,
				quantity
			}
		);
	}

	async addPartsToOrder(orderId: string, parts: DmsPart[], lineItemId: string): Promise<void> {
		return this.axios.post(`/order/${orderId}/part/bulk`,
			{
				parts,
				lineItemId
			}
		);
	}

	async updatePartFromOrder(orderId: string, partNumber: string, quantity: number, unitPriceNetValue: number, lineItemId: string): Promise<void> {
		return this.axios.patch(`/order/${orderId}/part`,
			{
				partNumber,
				quantity,
				unitPriceNetValue,
				lineItemId
			}
		);
	}

	async deletePartFromOrder(orderId: string, partNumber: string, lineItemId: string): Promise<void> {
		return this.axios.delete(`/order/${orderId}/part/${partNumber}`, {
			params: { lineItemId }
		});
	}

	async addTasksToOrder(orderId: string, tasks: DmsTask[], lineItemId: number): Promise<void> {
		return this.axios.post(`/order/${orderId}/task/bulk`,
			{
				tasks,
				lineItemId
			}
		);
	}

	async deleteTaskFromOrder(orderId: string, taskNumber: string, lineItemId: string): Promise<void> {
		return this.axios.delete(`/order/${orderId}/task/${taskNumber}`, {
			params: { lineItemId }
		});
	}

	async updateTaskFromOrder(orderId: string, task: DmsTask, lineItemId: string): Promise<void> {
		return this.axios.patch(`/order/${orderId}/task`,
			{
				task,
				lineItemId
			}
		);
	}

	async addTasksWithPartsToOrder(orderId: string, tasks: DmsTask[], parts: DmsPart[], lineItemId: number): Promise<void> {
		return this.axios.post(`/order/${orderId}/taskWithSpare/bulk`,
			{
				tasks,
				parts,
				lineItemId
			}
		);
	}

	async pingDealerWSConnections(): Promise<void> {
		return this.axios.get("/my/ws/ping");
	}
}

const DmsServiceInstance = new DmsService();
export default DmsServiceInstance;
